import React, { useState } from 'react';
import authService from '../../services/api/authService';
import { getRastId } from '../../utils/rastIdManager';
import './CustomerNameModal.css';

const CustomerNameModal = ({ isOpen, onClose, onSuccess }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Please enter your name');
      return;
    }

    setLoading(true);
    setError('');

    const customerData = authService.getCustomerData();
    const rastId = getRastId();

    const result = await authService.createCustomerTicket(
      name.trim(),
      customerData.phoneNumber,
      customerData.email,
      rastId
    );

    if (result.success) {
      onSuccess();
    } else {
      setError(result.error || 'Failed to create dining session. Please try again.');
    }

    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">Welcome!</h2>
          <p className="modal-subtitle">Let's start your dining experience</p>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="customerName">Your Name</label>
            <input
              type="text"
              id="customerName"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setError('');
              }}
              placeholder="Enter your name"
              className="form-input"
              disabled={loading}
              autoFocus
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className="submit-button"
            disabled={loading || !name.trim()}
          >
            {loading ? (
              <span className="loading-text">
                Creating session
                <span className="loading-dots">
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </span>
              </span>
            ) : (
              'Start Dining'
            )}
          </button>
        </form>

        <p className="modal-info">
          This will create your personal dining session for this visit
        </p>
      </div>
    </div>
  );
};

export default CustomerNameModal;

